import React, { useEffect, useState } from 'react'
import { Card, CardBody, Input, Badge } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { Btn } from '../../../AbstractElements'
import ExhibitorTypeService from '../../../Service/ExhibitorTypeService'
import { ExhibitorType } from './types'

interface Props {
  onAdd: () => void
  onEdit: (item: ExhibitorType) => void
  refresh: boolean
}

const ExhibitorTypeList: React.FC<Props> = ({ onAdd, onEdit, refresh }) => {
  const [data, setData] = useState<ExhibitorType[]>([])
  const [search, setSearch] = useState('')

  const fetchData = async () => {
    try {
      const response = await ExhibitorTypeService.getAll()
      setData(response.results)
    } catch (err) {
      console.error('Failed to fetch exhibitor types:', err)
    }
  }

  useEffect(() => {
    fetchData()
  }, [refresh])

  const filteredData = data.filter((item) => {
    return (
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      (item.require_tin ? 'yes' : 'no').includes(search.toLowerCase())
    )
  })

  const columns = [
    {
      name: 'Name',
      selector: (row: ExhibitorType) => row.name,
      sortable: true,
    },
    {
      name: 'Require TIN',
      cell: (row: ExhibitorType) => (
        <Badge color={row.require_tin ? 'success' : 'secondary'}>
          {row.require_tin ? 'Yes' : 'No'}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row: ExhibitorType) => (
        <>
          <Btn
            color="info"
            size="sm"
            onClick={() => onEdit(row)}
            className="me-2"
          >
            Edit
          </Btn>
          <Btn
            color="danger"
            size="sm"
            onClick={async () => {
              await ExhibitorTypeService.delete(row.id)
              fetchData()
            }}
          >
            Delete
          </Btn>
        </>
      ),
    },
  ]

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Input
            type="search"
            placeholder="Search exhibitor type..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ maxWidth: 300 }}
          />
          <Btn color="primary" onClick={onAdd}>
            Add Exhibitor Type
          </Btn>
        </div>

        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          striped
          noDataComponent="No exhibitor types found."
        />
      </CardBody>
    </Card>
  )
}

export default ExhibitorTypeList
